import { Card, Col, Row, Button, FloatButton, Timeline, Tooltip, Progress, Radio } from 'antd';
import { FiShare2 } from 'react-icons/fi';
import { CardHomeData, ExpirenceData, PartnersData, SocialData, SkillsData, SkillsTagsEnum } from '../../../utils/data';
import { useOutletContext } from 'react-router-dom';
import { UpcomingEventsComponent } from '../../../components/site/upcoming-events';
import { Emitter } from '../../../utils/emitter';
import { useState } from 'react';

export const SiteHomePage = () => {
    const [translate] = useOutletContext() as any;
    const guildHostUrl = 'https://guild.host/velrino/';
    const [skillTag, setSkillTag] = useState<any>('all');
    const [skills, setSkills] = useState<any>(SkillsData.sort((a, b) => a.name.localeCompare(b.name)));

    const handleSkillTag = (value: string) => {
        setSkills([])

        const skillsFiltered = (value === 'all') ? SkillsData : SkillsData.filter((item: any) => item.tags.includes(value));

        setSkillTag(value)

        setTimeout(() => {
            setSkills(skillsFiltered.sort((a, b) => a.name.localeCompare(b.name)));
        }, 50);
    }


    return (<>
        <div id="section_home" className="full-image-crop">
            <img src="/photos/banner-desktop.jpg" alt="Your Image" className="full-image desktop-image" />
            <img src="/photos/banner-mobile.jpg" alt="Your Image" className="full-image mobile-image" />
            <div className="text-overlay">
                <div className='text-overlay-content'>
                    <img alt="example" src="/photos/logo-white.png" height={75} className='animate__animated animate__zoomIn' id="banner" />
                    <div className="banner-subtitle">
                        {translate.t("section_home.title")}
                    </div>
                    <Button type="primary" className='button-base button-primary margin-top-medium animate__animated animate__infinite animate__pulse'
                        onClick={() => Emitter.EventEmitter.emit(Emitter.Event.Action.Anchor, 'section_about')}>
                        {translate.t("section_home.button")}
                    </Button>
                </div>
            </div>
        </div>
        <div id="section_about" className="site-content margin-top-medium padding-bottom-large min-full-height">
            <Row gutter={[16, 16]} justify={"center"}>
                <Col xs={24} lg={18}>
                    <Row gutter={[16, 16]} className='section-services' justify={"center"}>
                        <Col span={24} className='services-title'>
                            {translate.t("section_about.title")}
                        </Col>
                        <Col span={24}>
                            <Row justify={"center"}>
                                <Col xs={24} md={18} lg={12} className='services-subtitle'>
                                    {translate.t("section_about.description")}
                                </Col>
                            </Row>
                        </Col>
                        {
                            CardHomeData.map((item: any, index: number) => (<Col xs={24} md={12} lg={8} key={index}>
                                <Card className='bg-primary card-home'>
                                    <img alt="example" src={item.img} />
                                </Card>
                            </Col>))
                        }
                    </Row>
                </Col>
            </Row>
        </div>
        <div id="section_experiences" className="full-image-crop bg-primary">
            <Row gutter={[16, 16]} justify={"center"}>
                <Col xs={24} sm={18}>
                    <Row gutter={[16, 16]} className='section-services' justify={'center'}>
                        <Col span={24} className='services-title white-text'>
                            {translate.t("section_experiences.title")}
                        </Col>
                        <Col span={24}>
                            <div id="timeline">
                                {
                                    ExpirenceData.map((item: any, index: number) => (<div className="timeline-item" key={index}>
                                        <div>
                                            <div className="timeline-icon" style={{ backgroundColor: item.bgColor }}>
                                                <img src={item.img} height={item.height ? item.height : 30} />
                                            </div>
                                            <div className={'timeline-content text-left '.concat((index % 2 !== 0) ? 'right' : '')}>
                                                <p className="font-weight-bold">
                                                    <span>{item.title}</span>
                                                </p>
                                                <p className="font-weight-normal">
                                                    <span> {item.job} </span>
                                                </p>
                                                <p className="font-weight-normal">
                                                    <span>{item.period}</span>
                                                </p>
                                                <p className="description">
                                                    <span> {item?.desc} </span>
                                                </p>
                                            </div>
                                        </div>
                                    </div>))
                                }
                            </div>
                        </Col>
                    </Row>
                </Col >
            </Row >
        </div >
        <div id="section_skills" className="site-content margin-top-medium padding-bottom-large min-full-height">
            <Row gutter={[16, 16]} justify={"center"}>
                <Col xs={24} lg={18}>
                    <Row gutter={[16, 16]} className='section-services' justify={'center'}>
                        <Col span={24} className='services-title'>
                            {translate.t("section_skills.title")}
                        </Col>
                        <Col span={24} className='services-title'>
                            <Radio.Group value={skillTag} onChange={(e) => handleSkillTag(e.target.value)}>
                                <Radio.Button value="all">All</Radio.Button>
                                {
                                    Object.values(SkillsTagsEnum)
                                        .map((item: string, index: number) => <Radio.Button value={item} key={index}>{item}</Radio.Button>)
                                }
                            </Radio.Group>
                        </Col>
                        {
                            skills.map((item: any, index: number) => (<Col xs={24} md={8} lg={4} key={index}>
                                <Card className='card-skill animate__animated  animate__fadeIn'>
                                    <Progress type="circle" percent={item.value} strokeColor={{ '0%': '#fff' }} trailColor={'#30bae7'} />
                                    <div className='card-skill-logo'>
                                        <img src={item.img} />
                                    </div>
                                    <div className='card-skill-name'>{item.name}</div>
                                </Card>
                            </Col>))
                        }
                    </Row>
                </Col>
            </Row>
        </div>
        <div id="section_social" className="full-image-crop bg-primary">
            <div className="text-overlay">
                <Row gutter={[16, 16]} justify={"center"}>
                    <Col xs={24} sm={18}>
                        <Row gutter={[16, 16]} className='section-services' justify={'center'}>
                            <Col span={24} className='services-title white-text'>
                                <div className='center-content'>
                                    {translate.t("section_social.title")}
                                </div>
                            </Col>
                            <Col span={24}>
                                <Row justify={"center"} gutter={[16, 16]} align={"middle"}>
                                    {
                                        SocialData.map((social: any, index: number) => (<Col className='margin-bottom-medium' key={index}>
                                            <Tooltip placement="top" title={social.label.charAt(0).toUpperCase() + social.label.slice(1)}>
                                                <a href={social.link} className='social-icon social-icon-large social-square' target='_blank'>
                                                    {social.icon}
                                                </a>
                                            </Tooltip>
                                        </Col>))
                                    }
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </div>
        </div>
    </>)
}